export const MTHolodex = ({ front = "white", back = "#333" }) => {
  return (
    <svg
      width="100"
      height="100"
      viewBox="-2 -4 98 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.3806 74.8897L18.3806 17.3177L23.3806 20.3462L23.3806 71.8612L18.3806 74.8897Z"
        fill={back}
      />
      <path
        d="M21.6552 89.7418C24.1119 91.5307 27.5494 91.9303 30.5253 90.1277L91.9107 52.9463C97.0512 49.8327 97.0512 42.3746 91.9107 39.261L30.5253 2.0796C27.5493 0.277073 24.1119 0.676625 21.6552 2.46554L76.1901 35.4975C76.5935 35.7418 76.9764 36.0034 77.3389 36.2805L89.3203 43.5377C91.248 44.7053 91.248 47.5021 89.3203 48.6697L77.3389 55.9269C76.9764 56.2039 76.5935 56.4655 76.1901 56.7098L21.6552 89.7418Z"
        fill={back}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M71.3206 43.5376L9.93509 6.35625C7.93576 5.14524 5.38086 6.58476 5.38086 8.92225V83.2851C5.38086 85.6225 7.93576 87.0621 9.93511 85.8511L71.3206 48.6697C73.2483 47.502 73.2483 44.7053 71.3206 43.5376ZM12.5255 2.07958C7.19393 -1.14976 0.380859 2.68894 0.380859 8.92225V83.2851C0.380859 89.5184 7.19394 93.3571 12.5255 90.1277L73.911 52.9463C79.0515 49.8327 79.0515 42.3746 73.911 39.261L12.5255 2.07958Z"
        fill={front}
      />
    </svg>
  );
};

export const MTHolodexIcon = ({
  front = "var(--chakra-colors-n2-200)", // "var(--chakra-colors-n2-200)",
  back = "#333",
  ...rest
}) => {
  return (
    <svg
      width="63"
      height="63"
      viewBox="0 -3 63 60"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g>
        <path
          d="M13.6283 46.7477V10.1876L18.0283 12.8527L18.0283 44.0826L13.6283 46.7477Z"
          fill={back}
        />
        <path
          d="M17.2911 55.3319C19.7133 56.8903 22.9507 57.1614 25.7729 55.4519L58.9639 35.348C64.1044 32.2344 64.1044 24.7763 58.9639 21.6627L25.7729 1.55881C22.9742 -0.136384 19.7672 0.116064 17.3518 1.64015L23.0548 5.09447C23.2029 5.15924 23.3493 5.23502 23.4934 5.32228L56.6843 25.4262C58.9976 26.8273 58.9976 30.1835 56.6843 31.5846L23.4934 51.6885C23.2417 51.8409 22.9827 51.9583 22.7207 52.0432L17.2911 55.3319Z"
          fill={back}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M43.3588 25.3885L10.1678 5.28458C7.76861 3.83137 4.70273 5.55879 4.70273 8.36378V48.5716C4.70273 51.3766 7.76862 53.104 10.1678 51.6508L43.3588 31.5469C45.672 30.1458 45.672 26.7896 43.3588 25.3885ZM12.4474 1.52111C7.1158 -1.70823 0.302734 2.13046 0.302734 8.36378V48.5716C0.302734 54.8049 7.11581 58.6436 12.4474 55.4142L45.6384 35.3103C50.7788 32.1967 50.7788 24.7386 45.6383 21.625L12.4474 1.52111Z"
          fill={front}
        />
      </g>
    </svg>
  );
};
